import { type FC, useMemo } from 'react';

import { type TTgbStretchContext } from 'shared/types/bannerContext';
import { useAdfoxBannerContext } from 'shared/components/AdfoxBannerContext';
import { useBannerEnrichments } from 'shared/hooks/useBannerEnrichments';

import { getTgbStretchProps } from './internal/utils/getTgbStretchProps';
import { TgbStretch } from './TgbStretch';

type TTgbStretchContainerProps = {
  context: TTgbStretchContext;
};

export const TgbStretchContainer: FC<TTgbStretchContainerProps> = ({ context }) => {
  const bannerEnrichment = useBannerEnrichments(context);

  const { sizes } = useAdfoxBannerContext();

  const props = useMemo(
    () => getTgbStretchProps({ bannerEnrichment, context, sizes }),
    [bannerEnrichment, context, sizes],
  );

  return <TgbStretch {...props} />;
};
